import { Box, LoadingButton, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const PageContainer = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  position: 'relative',
}));

export const AuthCardBackground = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  backgroundColor: theme.palette.primary.main,
  /* prettier-ignore */
  backgroundImage: 'url(\'/assets/images/patientBack_AL.png\')',
  backgroundPosition: 'top left',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  position: 'relative',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-start',
  padding: theme.spacing(4),
  borderTopLeftRadius: theme.spacing(6.25),
  borderBottomLeftRadius: theme.spacing(6.25),
}));

export const MobileOnly = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

export const StyledFormGroup = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
}));

export const FormLabel = styled('label')(({ theme }) => ({
  fontSize: theme.typography.caption.fontSize,
  fontWeight: 400,
  width: 'fit-content',
  zIndex: 1,
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.common.white,
  marginBottom: theme.spacing(-2.4),
  marginLeft: theme.spacing(4),
  padding: theme.spacing(0, 1),
  lineHeight: 1.2,
}));

export const FormControl = styled('input')(({ theme }) => ({
  width: '100%',
  display: 'block',
  height: theme.spacing(14),
  padding: theme.spacing(2, 4),
  fontSize: '1.25rem',
  lineHeight: 1.5,
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.common.white,
  backgroundClip: 'border-box',
  border: `1px solid ${theme.palette.primary.dark}`,
  borderRadius: theme.spacing(1),
  outline: 'none',
  transition: 'border-color 0.15s ease-in-out',
  boxSizing: 'border-box',
  '&:focus': {
    boxShadow: `0 0 0 0.2rem ${theme.palette.primary.main}40`,
  },
  '&[aria-invalid="true"]': {
    borderColor: theme.palette.error.main,
  },
}));

export const FormEndAdornment = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(4),
  top: theme.spacing(8),
}));

export const FormTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(6),
}));

export const ErrorText = styled('div')(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: '0.875rem',
  marginTop: theme.spacing(0.5),
}));

export const ForgotPasswordContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(6),
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
}));

export const HelpTextContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(6),
  display: 'flex',
  justifyContent: 'center',
}));

export const PatientInfoContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
}));

export const StyledLoadingButton = styled(LoadingButton)(({ theme }) => ({
  width: '100%',
  padding: `${theme.spacing(4)} !important`,
  fontSize: '1.1rem !important',
  fontWeight: 'bold !important',
}));
